import { Component, OnInit } from '@angular/core';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { DiagnosticReport, DiagnosticReportLesson, DiagnosticReportRequest } from 'src/app/Elearning-Models';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { element } from 'protractor';
import { SimplePopupDialogComponent } from 'src/app/simple-popup-dialog/simple-popup-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-consumer-curriculum-demo-report',
  templateUrl: './consumer-curriculum-demo-report.component.html',
  styleUrls: ['./consumer-curriculum-demo-report.component.scss']
})
export class ConsumerCurriculumDemoReportComponent implements OnInit {

  currService: CurriculumService;

  report: DiagnosticReport;
  dataAvailable: boolean = false;
  studentConsumerCurriculumID: number = null;

  areasOfImprovement: any[] = [];
  areasOfExploration: any[] = [];

  totalMinusCountPercentage: string;
  aoiCountPercentage: string;
  aoeCountPercentage: string;

  constructor(
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.currService = this.serviceFactory.getCurriculumService();
   }

  ngOnInit(): void {
    
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.studentConsumerCurriculumID = +params.get('studentCurriculumID');
      
      var model: DiagnosticReportRequest = new DiagnosticReportRequest();
      model.StudentConsumerCurriculumID = this.studentConsumerCurriculumID;

      this.getConsumerCurriclumDiagnosticReport(model);
      
    });
  }


  private getConsumerCurriclumDiagnosticReport(model: DiagnosticReportRequest) {
    this.currService.GetConsumerCurriculumDiagnosticReport(model).subscribe((result: DiagnosticReport) => {
      
      this.report = result; 
      this.setFlipLessons(this.areasOfImprovement, this.report.NonProficientStandardLessons); 
      this.setFlipLessons(this.areasOfExploration, this.report.StandardsNotTestedLessons); 

      this.totalMinusCountPercentage = (((this.report.TotalLessons - (this.report.AOELessonCount + this.report.AOILessonCount)) / this.report.TotalLessons) * 100) + "%";
      this.aoiCountPercentage = ((this.report.AOILessonCount / this.report.TotalLessons) * 100) + "%";
      this.aoeCountPercentage = ((this.report.AOELessonCount / this.report.TotalLessons) * 100) + "%";

      this.dataAvailable = true;
    });

  }

  setFlipLessons(elementToPopulate: any[], sourceArray: DiagnosticReportLesson[]) {
    sourceArray?.forEach((lesson) => {
      lesson.Standards.forEach((standard) => {
        var existingRecord = elementToPopulate.find((element) => element.Standard.StandardCode == standard.StandardCode)
  
        if(!existingRecord){
          elementToPopulate.push({Standard: standard, Lessons: [lesson]});
        } 
        else 
        {
          var existingLesson = existingRecord.Lessons.find((element) => element.LessonName == lesson.LessonName);
          if (!existingLesson){
            existingRecord.Lessons.push(lesson);
          }
        };
      });
    });
  }

  navigateToMarketing(){
    this.router.navigate([environment.rootPath + '/CurriculumDiagnosticFeatures/' + this.studentConsumerCurriculumID]);
  }

  showStandardDescriptionPopUp(code: string, desc: string){
    const dialogRef = this.dialog.open(SimplePopupDialogComponent, {
      data: {
        okString: "Close",
        title: code + " Details",
        cancelString: "",
        dialog: desc
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (yes) => {
        if(yes){

        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

}
